export enum MainCardTypes {
  PremiumSubscription = 1,
  SmartTag = 2,
}
